import LaundriesProvider from "providers/LaundriesProvider"
import LoundriesTemplate from "components/templates/LoundriesTemplate"

const Loundries = () => {
    return(
        <LaundriesProvider>
            <LoundriesTemplate/>
        </LaundriesProvider>
    )
}

export default Loundries